"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.accountGrade.list': '价格套餐',
    'route.accountGrade.create': '创建价格套餐',
    'route.accountGrade.edit': '编辑价格套餐',
    'route.accountGrade.preview': '价格套餐预览',
};
